import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FocusLock, { FreeFocusInside } from 'react-focus-lock';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import './styles.scss';

const CreateModal = ({
  onCancel,
  onCreate,
  onTitleChange,
  isLoading,
  questionBankTabs,
}) => {
  const [title, setTitle] = useState('');

  const _onTitleChange = (event) => {
    const newTitle = event.target.value;
    setTitle(newTitle);
    onTitleChange && onTitleChange(newTitle);
  };

  const createQuizDetails = questionBankTabs
    ? 'Type a name to create a quiz.\nYour quiz will not be saved until you’ve added at least 1 question.'
    : 'Type a name to create a quiz, starting with this question.';

  const message = (
    <Fragment>
      <p className="whitespace-pre-line">{createQuizDetails}</p>
      <input
        type="text"
        placeholder="My Quiz"
        className="border border-solid rounded-full w-full h-12.6 text-gray-900 pl-4"
        onChange={_onTitleChange}
        value={title}
      />
      <p className="pt-4">
        To add questions to an existing quiz, find the quiz you wish to edit
        under &#39;Resources & Assignments &#62; All Resources&#39; first.
      </p>
    </Fragment>
  );

  const cancel = () => {
    onCancel && onCancel();
  };

  const create = async () => {
    onCreate && onCreate();
  };

  const btnPrimary = isLoading ? <LoadingSpinner height={16} /> : 'Create Quiz';
  const btnSecondary = 'Cancel';

  return (
    <FocusLock group="part-of-screen-modal">
      <FreeFocusInside>
        <ConfirmDialog
          size="small"
          title="Create a Quiz?"
          content={{
            btnPrimary,
            btnSecondary,
          }}
          isPrimaryBtnDisabled={Boolean(!title.trim()) || isLoading}
          onClose={cancel}
          onSuccess={() => !!title.trim() && create()}
        >
          {message}
        </ConfirmDialog>
      </FreeFocusInside>
    </FocusLock>
  );
};

CreateModal.displayName = 'CreateModal';

CreateModal.propTypes = {
  /**
   * Parent handler for canceling the Quiz creation.
   * */
  onCancel: PropTypes.func.isRequired,
  /**
   * Parent handler for Quiz creation notification.
   * */
  onCreate: PropTypes.func.isRequired,
  /**
   * Disable primary action button when this prop is true
   * */
  isLoading: PropTypes.bool,
  questionBankTabs: PropTypes.bool,
};

CreateModal.defaultProps = {
  questionBankTabs: false,
  isLoading: false,
};

const mapStateToProps = ({
  featureFlag: { question_bank_tabs: questionBankTabs },
}) => ({
  questionBankTabs,
});

export default connect(mapStateToProps)(CreateModal);
